import React from 'react';
import { Button } from '@mui/material';
import { PersonAdd as PersonAddIcon } from '@mui/icons-material';

/** "Add User Seats" button — app theme, small size; same in Header and Subscription. */
const AddUserSeatsButton = ({ onClick, disabled = false, size = 'small', sx = {}, ...rest }) => (
  <Button
    variant="outlined"
    color="primary"
    size={size}
    startIcon={<PersonAddIcon />}
    onClick={onClick}
    disabled={disabled}
    sx={{
      fontWeight: 600,
      textTransform: 'none',
      minWidth: 100,
      ...sx,
    }}
    {...rest}
  >
    Add User Seats
  </Button>
);

export default AddUserSeatsButton;
